module.exports = __webpack_public_path__ + "assets/images/small-multiples/tablet.svg?v=0365f8fd";